var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconExpand(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 10,
    viewBox: "0 0 14 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.0258484 2.17749C0.0278549 1.82861 0.101846 1.4841 0.242975 1.16651C0.390924 0.823032 0.63236 0.53039 0.93845 0.323538C1.24454 0.116687 1.60234 0.00436949 1.96913 0L11.1101 0C11.4769 0.00436949 11.8347 0.116687 12.1408 0.323538C12.4469 0.53039 12.6883 0.823032 12.8363 1.16651C13.0187 1.56173 13.089 2.00144 13.0391 2.43553C12.9892 2.86963 12.8211 3.28065 12.554 3.62175L7.98352 9.28767C7.81067 9.50986 7.59108 9.68929 7.34109 9.81262C7.09111 9.93595 6.81716 10 6.53963 10C6.26211 10 5.98816 9.93595 5.73817 9.81262C5.48819 9.68929 5.2686 9.50986 5.09575 9.28767L0.525238 3.62175C0.201583 3.21333 0.0252342 2.70332 0.0258484 2.17749Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconExpand);
export default __webpack_public_path__ + "static/media/iconExpand.a17c2935233673c100259664c5716ed8.svg";
export { ForwardRef as ReactComponent };